import React from "react";

// state
import { AppProvider } from "./ResourcesContext";

import ResourcesFilters from "./ResourcesFilters";
import ResourcesGrid from "./ResourcesGrid";

// all the logic of the app is handles in the app context file

const App = () => {
	return (
		<AppProvider>
			<ResourcesFilters />
			<ResourcesGrid />
		</AppProvider>
	);
};

export default App;
